// Supports both the short marker (`[Inferred—verify]`) and the seeded
// placeholder form (`[Inferred—verify what makes it unique]`).
const UNCERTAINTY_LABEL = /\[(?:Needs client clarification|Inferred(?:—|-)verify)[^\]]*\]/i;

export const hasUnresolvedUncertaintyLabel = (value: unknown, seen = new WeakSet<object>()): boolean => {
  if (typeof value === 'string') return UNCERTAINTY_LABEL.test(value);
  if (Array.isArray(value)) return value.some((item) => hasUnresolvedUncertaintyLabel(item, seen));
  if (!value || typeof value !== 'object' || seen.has(value)) return false;
  seen.add(value);
  return Object.values(value).some((item) => hasUnresolvedUncertaintyLabel(item, seen));
};
